module.exports = __webpack_public_path__ + "img/iso1328-1-2013_figF01_single-flank-tester.fcb809ed.png";